import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  ShoppingCartOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  DollarOutlined,
  AppstoreOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <ShoppingCartOutlined />,
  1: <FileSearchOutlined />,
  2: <FileTextOutlined />,
  3: <DollarOutlined />,
};

const HighlightsSection = () => {
  const { t } = useTranslation("pms");

  const items = useMemo(() => {
    const raw = t("highlights.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  const statFlow = useMemo(() => {
    const raw = t("highlights.stat_flow", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as string[];
  }, [t]);

  const statValue = t("highlights.stat_value");
  const statLabel = t("highlights.stat_label");
  const statDesc = t("highlights.stat_desc");

  return (
    <section className="dev-pms-section dev-pms-highlights-section">
      <div className="dev-pms-section-inner">
        <h2 className="dev-section-h2 dev-pms-section-h2">
          <span className="dev-pms-section-h2-icon dev-pms-section-h2-icon--cyan" aria-hidden>
            <AppstoreOutlined />
          </span>
          <span>{t("highlights.title")}</span>
        </h2>

        <div className="dev-pms-highlights-grid">
          <div className="dev-pms-highlight-list">
            {items.map((item, idx) => (
              <div key={idx} className="dev-pms-highlight-item">
                <div className="dev-pms-highlight-icon">
                  {iconByIndex[idx] ?? <ShoppingCartOutlined />}
                </div>
                <div>
                  <div className="dev-pms-highlight-title">{item.title}</div>
                  <div className="dev-pms-highlight-desc">{item.desc}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="dev-pms-stat-card dev-pms-stat-card--savings">
            <div className="dev-pms-stat-value">{statValue}</div>
            <div className="dev-pms-stat-label">{statLabel}</div>
            <div className="dev-pms-stat-desc">{statDesc}</div>
            {statFlow.length > 0 && (
              <div className="dev-pms-stat-flow">
                {statFlow.map((step, idx) => (
                  <span key={step} className="dev-pms-stat-flow-item">
                    {idx > 0 && <ArrowRightOutlined className="dev-pms-stat-flow-arrow" />}
                    <span>{step}</span>
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;
